/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    EodMelcoEodModelsScanRequest,
    EodMelcoEodModelsScanRequestFromJSON,
    EodMelcoEodModelsScanRequestToJSON,
    EodMelcoEodModelsScanResponse,
    EodMelcoEodModelsScanResponseFromJSON,
    EodMelcoEodModelsScanResponseToJSON,
    EodMelcoEodModelsTrackLoadDesignRequest,
    EodMelcoEodModelsTrackLoadDesignRequestFromJSON,
    EodMelcoEodModelsTrackLoadDesignRequestToJSON,
    EodMelcoModelsBoolResponse,
    EodMelcoModelsBoolResponseFromJSON,
    EodMelcoModelsBoolResponseToJSON,
    EodMelcoModelsError,
    EodMelcoModelsErrorFromJSON,
    EodMelcoModelsErrorToJSON,
} from '../models';

export interface MachineJobsApiEodMachineScanRequest {
    eodMelcoEodModelsScanRequest?: EodMelcoEodModelsScanRequest;
}

export interface MachineJobsApiEodMachineTrackRequest {
    eodMelcoEodModelsTrackLoadDesignRequest?: EodMelcoEodModelsTrackLoadDesignRequest;
}

/**
 * 
 */
export class MachineJobsApi extends runtime.BaseAPI {

    /**
     */
    async eodMachineScanRaw(requestParameters: MachineJobsApiEodMachineScanRequest): Promise<runtime.ApiResponse<EodMelcoEodModelsScanResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/eod/machine/scan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EodMelcoEodModelsScanRequestToJSON(requestParameters.eodMelcoEodModelsScanRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EodMelcoEodModelsScanResponseFromJSON(jsonValue));
    }

    /**
     */
    async eodMachineScan(requestParameters: MachineJobsApiEodMachineScanRequest): Promise<EodMelcoEodModelsScanResponse> {
        const response = await this.eodMachineScanRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async eodMachineTrackRaw(requestParameters: MachineJobsApiEodMachineTrackRequest): Promise<runtime.ApiResponse<EodMelcoModelsBoolResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/eod/machine/track/load`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EodMelcoEodModelsTrackLoadDesignRequestToJSON(requestParameters.eodMelcoEodModelsTrackLoadDesignRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EodMelcoModelsBoolResponseFromJSON(jsonValue));
    }

    /**
     */
    async eodMachineTrack(requestParameters: MachineJobsApiEodMachineTrackRequest): Promise<EodMelcoModelsBoolResponse> {
        const response = await this.eodMachineTrackRaw(requestParameters);
        return await response.value();
    }

}
